@import "../../../helpers/helpers";

.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  opacity: 0.1;
  background: black;
}

// Todo -- import typography.scss ?
.h1 {
  margin-bottom: 20px;
  text-transform: uppercase;

  @extend %sans-bold;
}

.fieldOptionList {
  margin: 20px 0;
  column-count: 2;
  line-height: 1;
}

.fieldOption {
  button {
    padding: 0;
    appearance: none;
    font-size: 16px;
    border: none;
    background: none;
    cursor: pointer;

    @extend %sans-bold;

    &:hover {
      opacity: 0.5;
    }
  }

  input[type="checkbox"] {
    @extend %checkbox;
  }

  label {
    padding: 1px 7px;
    cursor: pointer;
    user-select: none;
    @extend %sans-bold;
  }
}

.lineBreak {
  margin-bottom: 16px;
}

.columnBreak {
  break-after: column;
}

.selectAllButton {
  border-bottom: 1px solid black;
  cursor: pointer;
}

.submitArea {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;

  p {
    align-self: center;
    margin-right: 16px;
    color: #b94a48;
    animation: 1.2s alertFadeOut;
  }
}

.button {
  @extend %button;
  @extend %sans-bold;
  font-size: 16px;
  background-color: white;
}

.unstyledButton {
  @extend %sans-bold;
  appearance: none;
  background: none;
  border: none;
  padding: 0 8px 0 0;
  font-size: inherit;
  display: block;
  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    color: #e8e8e8;
  }
}

.submit {
  @extend .button;
  margin: 0 0 0 auto;
  min-width: 216px;
  align-self: center;

  &.buttonLoading {
    opacity: 0.5;
    pointer-events: none;
  }
}

.confirm {
  margin: 10px 0 24px;
}

.successNotice {
  margin-right: 30px;
}
